import { render, staticRenderFns } from "./communicationDashboardQRCode.vue?vue&type=template&id=06c43898&scoped=true"
import script from "./communicationDashboardQRCode.vue?vue&type=script&lang=js"
export * from "./communicationDashboardQRCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c43898",
  null
  
)

export default component.exports